<!-- Created by henian.xu on 2020/3/26. -->

<template>
    <div
        class="credentials-item"
        v-bind="linkerProps"
        v-on="excludeInputListeners"
    >
        <div class="header">
            <XIcon
                content="f08a"
                theme="main"
            />
            <XLabel>{{dataset.applyMaterialsName}}</XLabel>
        </div>
        <div class="body">
            <div class="inner">
                <dl v-if="dataset.certCatName">
                    <dt>关联证书:</dt>
                    <dd>{{dataset.certCatName}}</dd>
                </dl>
                <dl>
                    <dt>更新时间:</dt>
                    <dd>{{dataset.lastUpdateTime | moment('YYYY-MM-DD HH:mm:ss')}}</dd>
                </dl>
                <dl v-if="dataset.expireTime">
                    <dt>有效截止:</dt>
                    <dd>{{dataset.expireTime | moment()}}</dd>
                </dl>
            </div>
            <XIcon
                content="f012"
                size="small"
                theme="g5"
            />
        </div>
        <div class="footer">
            <XButton
                :label="dataset.expireStatusName"
                :theme="!dataset.expireStatus?'danger':''"
                link
            />
        </div>
    </div>
</template>

<script>
import { linkerMixin, listenersMixin } from 'packages/mixins';

export default {
    name: 'CredentialsItem',
    mixins: [linkerMixin, listenersMixin],
    data() {
        return {};
    },
    props: {
        dataset: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {},
};
</script>

<style lang="scss">
.credentials-item {
    display: block;
    background-color: $color-component-bgc;
    //border-radius: $padding;
    border: 1px solid $color-border;
    overflow: hidden;
    @include boxShadow();

    > .header {
        margin: $padding;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > .x-icon {
            margin-right: $margin-small;
        }
        > .x-label {
            flex: 1;
            font-weight: bold;
        }
    }
    > .body {
        margin: $padding;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        > .inner {
            flex: 1;
            dl {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-start;
                + dl {
                    margin-top: $margin-small;
                }
                > dt {
                    flex: 0 0 auto;
                }
                > dd {
                    flex: 1;
                }
            }
        }
    }
    > .footer {
        margin: $padding 0;
        text-align: right;
    }
}
</style>
